'use strict';

import 'brg';
import angular from 'angular';
import toastrModule from 'angular-toastr';

import componentsModule from './components';
import servicesModule from './services';
import versionsModule from './versions';
import filtersModule from './filters';
import styleModule from './style';
import controllersModule from './controllers';

const MODULE_NAME = 'daupler.incidents';

var app = angular.module(MODULE_NAME, [
  'ngAnimate',
  'ngSanitize',
  'ui.tree',
  toastrModule,
  'brg.config.django',
  'brg.style.bootstrap3',
  'brg.components.inputs',
  'brg.config.ui.mask',
  componentsModule,
  servicesModule,
  versionsModule,
  filtersModule,
  styleModule,
  controllersModule,
]);

// TODO: GET RID OF THIS STUFF
app.config(function (pusherProvider) {
  'ngInject';
  pusherProvider.setAppKey(process.env.PUSHER_APP_KEY);
  pusherProvider.setAppCluster(process.env.PUSHER_APP_CLUSTER);
});

export default MODULE_NAME;
